module.exports = __webpack_public_path__ + "static/img/img3.60187e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page_index/img3.png
// module id = juX5
// module chunks = 1